import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Projects.css";

const ProjectsInfo = ({ projectData }) => {
  const { id, title, description, image } = projectData;
  const [imgLoaded, setImgLoaded] = useState(false);
  const [imgError, setImgError] = useState(false);

  return (
    <div className="project-column">
      <article className="project-card" data-aos="zoom-out" data-aos-easing="linear" data-aos-duration="1000">
        <div className="project-image-wrap">
          {!imgLoaded && !imgError && <span className="project-img-loader" aria-hidden="true" />}
          {!imgError ? (
            <img
              src={image}
              className={`project-image${imgLoaded ? " is-loaded" : " is-loading"}`}
              alt={`${title} project preview`}
              loading="lazy"
              decoding="async"
              onLoad={() => setImgLoaded(true)}
              onError={() => setImgError(true)}
            />
          ) : (
            <span className="project-img-fallback" role="img" aria-label={`${title} project preview`}>
              {title ? title.charAt(0).toUpperCase() : "P"}
            </span>
          )}
          <span className="project-index">/{String(id).padStart(2, "0")}</span>
        </div>
        <div className="project-body">
          <p className="project-type">Selected project</p>
          <h2 className="project-title">{title}</h2>
          <p className="project-description">{description}</p>
        </div>
        <div className="project-footer">
          <Link to={`/project/${id}`} className="card-btn">
            View details <span aria-hidden="true">↗</span>
          </Link>
        </div>
      </article>
    </div>
  );
};

export default ProjectsInfo;

// {
//     "id": "4",
//         "title": "LEARNING ZONE",
//             "description": "A web application using MERN Stack for providing e-learning services. Developed using HTML, Bootstrap, React, Node.js, Express.js, CRUD operations, MongoDB, and FirebaseAuth",
//                 "liveLink": "https://learning-zone-bd.web.app/",
//                     "clientSideRepository": "https://github.com/shoieb-dev/learning-zone-bd-client-side",
//                         "tools": [
//                             "HTML5",
//                             "CSS3",
//                             "Bootstrap",
//                             "React",
//                             "Node.js",
//                             "Express.js",
//                             "MongoDB",
//                             "Firebase Auth."
//                         ],
//                             "image": "https://i.ibb.co/phTSNvs/image.png",
//                                 "image1": "https://i.ibb.co/N15Lqss/image.png",
//                                     "image2": "https://i.ibb.co/c87hKSb/image.png",
//                                         "image3": "https://i.ibb.co/60tf9DR/image.png"
// },
// {
//     "id": "5",
//         "title": "LEARNING ZONE",
//             "description": "A web application using MERN Stack for providing e-learning services. Developed using HTML, Bootstrap, React, Node.js, Express.js, CRUD operations, MongoDB, and FirebaseAuth",
//                 "liveLink": "https://learning-zone-bd.web.app/",
//                     "clientSideRepository": "https://github.com/shoieb-dev/learning-zone-bd-client-side",
//                         "tools": [
//                             "HTML5",
//                             "CSS3",
//                             "Bootstrap",
//                             "React",
//                             "Node.js",
//                             "Express.js",
//                             "MongoDB",
//                             "Firebase Auth."
//                         ],
//                             "image": "https://i.ibb.co/phTSNvs/image.png",
//                                 "image1": "https://i.ibb.co/N15Lqss/image.png",
//                                     "image2": "https://i.ibb.co/c87hKSb/image.png",
//                                         "image3": "https://i.ibb.co/60tf9DR/image.png"
// },
// {
//     "id": "6",
//         "title": "LEARNING ZONE",
//             "description": "A web application using MERN Stack for providing e-learning services. Developed using HTML, Bootstrap, React, Node.js, Express.js, CRUD operations, MongoDB, and FirebaseAuth",
//                 "liveLink": "https://learning-zone-bd.web.app/",
//                     "clientSideRepository": "https://github.com/shoieb-dev/learning-zone-bd-client-side",
//                         "tools": [
//                             "HTML5",
//                             "CSS3",
//                             "Bootstrap",
//                             "React",
//                             "Node.js",
//                             "Express.js",
//                             "MongoDB",
//                             "Firebase Auth."
//                         ],
//                             "image": "https://i.ibb.co/phTSNvs/image.png",
//                                 "image1": "https://i.ibb.co/N15Lqss/image.png",
//                                     "image2": "https://i.ibb.co/c87hKSb/image.png",
//                                         "image3": "https://i.ibb.co/60tf9DR/image.png"
// },
// {
//     "id": "6",
//         "title": "LEARNING ZONE",
//             "description": "A web application using MERN Stack for providing e-learning services. Developed using HTML, Bootstrap, React, Node.js, Express.js, CRUD operations, MongoDB, and FirebaseAuth",
//                 "liveLink": "https://learning-zone-bd.web.app/",
//                     "clientSideRepository": "https://github.com/shoieb-dev/learning-zone-bd-client-side",
//                         "tools": [
//                             "HTML5",
//                             "CSS3",
//                             "Bootstrap",
//                             "React",
//                             "Node.js",
//                             "Express.js",
//                             "MongoDB",
//                             "Firebase Auth."
//                         ],
//                             "image": "https://i.ibb.co/phTSNvs/image.png",
//                                 "image1": "https://i.ibb.co/N15Lqss/image.png",
//                                     "image2": "https://i.ibb.co/c87hKSb/image.png",
//                                         "image3": "https://i.ibb.co/60tf9DR/image.png"
// },
// {
//     "id": "6",
//         "title": "LEARNING ZONE",
//             "description": "A web application using MERN Stack for providing e-learning services. Developed using HTML, Bootstrap, React, Node.js, Express.js, CRUD operations, MongoDB, and FirebaseAuth",
//                 "liveLink": "https://learning-zone-bd.web.app/",
//                     "clientSideRepository": "https://github.com/shoieb-dev/learning-zone-bd-client-side",
//                         "tools": [
//                             "HTML5",
//                             "CSS3",
//                             "Bootstrap",
//                             "React",
//                             "Node.js",
//                             "Express.js",
//                             "MongoDB",
//                             "Firebase Auth."
//                         ],
//                             "image": "https://i.ibb.co/phTSNvs/image.png",
//                                 "image1": "https://i.ibb.co/N15Lqss/image.png",
//                                     "image2": "https://i.ibb.co/c87hKSb/image.png",
//                                         "image3": "https://i.ibb.co/60tf9DR/image.png"
// }
